import React from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon, PhoneIcon } from 'lucide-react';
import { Seo } from '../components/Seo';
import { PageHeader } from '../components/PageHeader';
import { CtaBand } from '../components/CtaBand';
import { useLanguage } from '../contexts/LanguageContext';
import { business } from '../data/business';
import { copy } from '../data/copy';
import { services } from '../data/services';
export function Services() {
  const {
    t
  } = useLanguage();
  const page = copy.pages.services;
  return <>
      <Seo title={t(copy.seo.services.title)} description={t(copy.seo.services.description)} data-id="element-471" data-mp="3t94ff99g3fm4" />
      <PageHeader eyebrow={t(page.eyebrow)} title={t(page.title)} description={t(page.description)} data-id="element-472" data-mp="b1yjj2ai56fx" />

      <section className="border-b border-navy-100 bg-white" data-id="element-473" data-mp="2cv5vc1qwp5x2">
        <nav aria-label={t(page.jumpLabel)} className="mx-auto flex max-w-7xl flex-wrap gap-2 px-6 py-5" data-id="element-474" data-mp="2cvnyzjfwemf0">
          {services.map(service => <a key={service.slug} href={`#${service.slug}`} className="rounded-full border border-navy-200 px-4 py-2 text-sm font-semibold text-navy-700 transition-colors duration-150 ease-smooth hover:border-navy-400 hover:text-navy-900" data-id="element-475" data-mp="16q46mgps6gj7">
              {t(service.name)}
            </a>)}
        </nav>
      </section>

      <div className="bg-white" data-id="element-476" data-mp="1pe97ngf1zneb">
        <div className="mx-auto max-w-7xl divide-y divide-navy-100 px-6" data-id="element-477" data-mp="1pf2k8y0p174d">
          {services.map((service, index) => {
          const Icon = service.icon;
          return <article key={service.slug} id={service.slug} className="scroll-mt-32 py-14 sm:py-16" data-id="element-478" data-mp="1ze03blfco8fz" data-mpi={index}>
                <div className={`grid items-start gap-10 ${service.image ? 'lg:grid-cols-2 lg:gap-14' : ''}`} data-id="element-479" data-mp="4zz3ax82dfeb">
                  <div data-id="element-480" data-mp="1cbq4fvavr65l">
                    <span className="inline-flex h-12 w-12 items-center justify-center rounded-md bg-navy-900 text-gold-400" data-id="element-481" data-mp="1cd18lw88mfx8">
                      <Icon width={24} height={24} aria-hidden="true" data-id="element-482" data-mp="17egb44kdeach" />
                    </span>
                    <h2 className="mt-5 font-display text-3xl font-bold tracking-tight text-navy-900" data-id="element-483" data-mp="1le7pw7ipnurj">
                      {t(service.name)}
                    </h2>
                    {service.price && <p className="mt-3 inline-block rounded-md bg-gold-100 px-3 py-1.5 font-display text-sm font-bold text-gold-800" data-id="element-484" data-mp="1v8znhbcamhmb">
                        {t(service.price)}
                      </p>}
                    <p className="mt-4 max-w-xl text-lg leading-relaxed text-navy-600" data-id="element-485" data-mp="201key67q8imo">
                      {t(service.description)}
                    </p>
                    <ul className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-486" data-mp="2e1v6zckrw39f">
                      {service.includes.map(item => <li key={item.en} className="flex gap-2.5 text-navy-800" data-id="element-487" data-mp="290eadt9bn2yn">
                          <CheckIcon width={18} height={18} aria-hidden="true" className="mt-1 shrink-0 text-gold-600" data-id="element-488" data-mp="2sly03i3ve6z6" />
                          <span data-id="element-489" data-mp="2nnwhsze9qbor">{t(item)}</span>
                        </li>)}
                    </ul>
                    {service.price && <p className="mt-5 text-sm text-navy-500" data-id="element-490" data-mp="2eo9f8a9syzu4">
                        {t(page.priceNote)}
                      </p>}
                    <div className="mt-8 flex flex-col gap-3 sm:flex-row" data-id="element-491" data-mp="200y60f13frx6">
                      <Link to="/contact" className="flex min-h-[48px] items-center justify-center rounded-md bg-gold-500 px-6 font-bold text-navy-950 transition-colors duration-150 ease-smooth hover:bg-gold-400" data-id="element-492" data-mp="24zhrkebrz1p0">
                        {t(copy.cta.bookThisService)}
                      </Link>
                      <a href={business.phoneHref} className="flex min-h-[48px] items-center justify-center gap-2 rounded-md border border-navy-200 px-6 font-bold text-navy-900 transition-colors duration-150 ease-smooth hover:bg-navy-50" data-id="element-493" data-mp="1iy93n9u0xpwr">
                        <PhoneIcon width={17} height={17} aria-hidden="true" data-id="element-494" data-mp="157403wnjcdh5" />
                        {t(copy.cta.askQuestion)}
                      </a>
                    </div>
                  </div>

                  {service.image && <img src={service.image} alt={`${t(service.name)} — A&J Auto Repair`} loading={index > 1 ? 'lazy' : undefined} className="w-full rounded-xl object-cover ring-1 ring-navy-100 lg:aspect-[4/3]" data-id="element-495" data-mp="v8wuub2lzjuz" />}
                </div>
              </article>;
        })}
        </div>
      </div>

      <CtaBand title={page.ctaTitle} description={page.ctaDescription} data-id="element-496" data-mp="cc67471pi9d3" />
    </>;
}